"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const material_1 = require("@angular/material");
const _4d_mapper_1 = require("4d-mapper");
const router_1 = require("@angular/router");
const app_service_1 = require("../app.service");
const map_service_1 = require("../map.service");
const reference_annotation_markedImages_1 = require("../../main/map/photogram/reference-annotation-markedImages");
const Constants_1 = require("../Constants");
const event_listener_interface_1 = require("@src/app/xs/interfaces/event-listener.interface");
const identify_interface_1 = require("@src/app/xs/interfaces/identify.interface");
const application_events_service_1 = require("@src/app/xs/services/events/application-events.service");
const public_3d_renderer_1 = require("@src/app/v2/commons/cesium/public-3d-renderer");
const map_viewer_service_1 = require("@src/app/service/map-viewer.service");
const Cesium = window.Cesium;
class MapDialog {
    constructor(dialogRef, data, fourD, mapService, cesiumMapService, applicationEvents) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.fourD = fourD;
        this.mapService = mapService;
        this.cesiumMapService = cesiumMapService;
        this.applicationEvents = applicationEvents;
        this.__ID = null;
        this.__EVENTS = null;
        this.rot_head = 0;
        this.rot_pitch = 0;
        this.rot_roll = 0;
        this.currentColor = '#ff0000';
        this.loading = false;
        this.transform = this.data.items.length > 0 ? this.data.items[0] : null;
        if (this.transform && this.transform['customColor']) {
            this.currentColor = this.transform['customColor'];
        }
        this.inputType = this.data.dataset.dataType.uid;
        if ((this.inputType == 'laslaz' || this.inputType == 'laslaz-tiles') && this.transform && !this.transform.pointCloudShading) {
            this.transform.pointCloudShading = {
                'geometricErrorScale': 1,
                'attenuation': true,
                'maximumAttenuation': 8,
                'baseResolution': 0,
                'eyeDomeLighting': false,
                'eyeDomeLightingStrength': 1,
                'eyeDomeLightingRadius': 1
            };
            this.transform.saveObservable().subscribe();
            this.mapService.currentProject = null;
        }
    }
    // ___mapViewer ( incoming:any = null ) {
    //   this.viewer = incoming.viewer;
    //   this.init();
    // }
    setCurrentColor() {
        if (this.transform) {
            this.helper.removePlottable(this.transform);
            this.transform['customColor'] = this.currentColor;
            this.helper.addPlottable(this.transform).subscribe();
        }
    }
    ngAfterViewInit() {
        this.__ID = identify_interface_1.XsIdentityInterface.__init(this);
        this.__EVENTS = event_listener_interface_1.XsEventListenerInterface.__init(this);
        // console.log('## MAP-VIEWER DIALOG');
        let map = this.cesiumMapService.getMap('dialog');
        if (map) {
            this.viewer = map.viewer;
            this.helper = map.helper;
            this.init();
        }
    }
    init() {
        // console.log('## INIT');
        // this.helper = new FourdCesiumHelper(this.fourD, this.viewer)
        this.helper.registerRenderer(_4d_mapper_1.Transform, 'public-3d', new public_3d_renderer_1.Public3DRenderer(this.helper));
        // this.viewer = this.map.viewer;
        if (this.transform && this.transform['clipGlobe'] != undefined) {
            // this.mapService.loadCesium(this.viewer)
            this.mapService.clipedEntity = undefined;
            this.mapService.clipGlobe(this.transform['clipGlobe'], this.transform);
        }
        /*if(this.viewer.scene){
          this.viewer.scene.mode = Cesium.SceneMode.SCENE3D;
        }*/
        this.handler = new Cesium.ScreenSpaceEventHandler(this.viewer.canvas);
        this.handler.setInputAction((movement) => this.clickedPoint(movement), Cesium.ScreenSpaceEventType.LEFT_CLICK);
        this.handler.setInputAction((movement) => this.clickedPoint(movement), Cesium.ScreenSpaceEventType.RIGHT_CLICK);
        if (this.transform) {
            this.helper.addPlottable(this.transform).subscribe(s => {
                this.helper.sendCameraTo(this.transform);
                this.obj = s;
                if (this.obj.object.modelMatrix) {
                    var polly = JSON.parse(JSON.stringify(this.obj.object.modelMatrix));
                    this.obj.object.modelMatrix = Cesium.Matrix4.IDENTITY;
                    this.origin = JSON.parse(JSON.stringify(this.obj.boundingSphere.center));
                    this.obj.object.modelMatrix = polly;
                }
            });
            //plot kml file using frontend code, till we are able to merge a8 to master then move plotting kml to sdk
        }
        else if (this.inputType === 'kml') {
            // this.loading = true;
            var options = {
                camera: this.viewer.scene.camera,
                canvas: this.viewer.scene.canvas
            };
            Constants_1.Constants.showHangOn();
            this.viewer.dataSources.add(Cesium.KmlDataSource.load(this.data.dataset.file('data'), options)).then((dataSource) => {
                this.viewer.flyTo(dataSource);
                this.kmlDataSource = dataSource;
                Constants_1.Constants.hideHangOn();
                this.loading = false;
            });
        }
    }
    /*redraw(){
      var rotation =  new Cesium.HeadingPitchRoll(
          Cesium.Math.toRadians(this.rot_heading),
          Cesium.Math.toRadians(this.rot_pitch),
          Cesium.Math.toRadians(this.rot_roll)
      )
      var negCenter = new Cesium.Cartesian3(-this.origin.x, -this.origin.y, -this.origin.z)
      var testPoint = new Cesium.Cartesian3(this.origin.x, this.origin.y, this.origin.z + 1)
  
      var negTrans = Cesium.Matrix4.fromTranslation(negCenter,{})
      var posTrans = Cesium.Matrix4.fromTranslation(this.origin,{})
  
  
  
      var trans = Cesium.Matrix4.multiplyTransformation(rotate,negTrans,{})
  
      var trans2 = Cesium.Matrix4.multiplyTransformation(trans,posTrans,{})
  
      console.log(Cesium.Cartesian3.subtract(Cesium.Matrix4.multiplyByPoint(trans2,testPoint,{}),this.origin,{}))
      // move object back to origin the object should be translated to after
      this.obj.object.modelMatrix = Cesium.Matrix4.multiplyByTranslation(trans2, this.transform['translation'] || Cesium.Cartesian3.ZERO,{})
  
  
  
  
    }
    clickedPoint(movement){
  
        this.viewer.selectedEntity = null
        if(this.setAlign){
          var pickedObject = this.viewer.scene.pickPosition(movement.position);
  
          var carto = Cesium.Cartographic.fromCartesian(pickedObject)
  
          var offset = Cesium.Cartesian3.fromRadians(carto.longitude, carto.latitude,   (this.vertical_offset || 0));
          var translation = Cesium.Cartesian3.subtract(offset, this.origin, new Cesium.Cartesian3());
  
          this.transform['translation'] = translation
  
          this.redraw()
        }
  
    }
  
  
    voff(){*/
    useHeight() {
        if (this.transform && this.obj) {
            var cartographic = Cesium.Cartographic.fromCartesian(this.obj.boundingSphere.center);
            var surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 0.0);
            var offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, this.transform.vertical_offset || 0);
            var translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3());
            this.obj.object.modelMatrix = Cesium.Matrix4.fromTranslation(translation);
        }
    }
    adjustPoint(point = this.lastClick) {
        var matrix = Cesium.Matrix4.IDENTITY;
        if (Math.abs(this.origin.x) < 1000) {
            var m = Cesium.Transforms.eastNorthUpToFixedFrame(point, Cesium.Ellipsoid.WGS84, {});
            var rotation = new Cesium.HeadingPitchRoll(Cesium.Math.toRadians(this.rot_head), Cesium.Math.toRadians(this.rot_pitch), Cesium.Math.toRadians(this.rot_roll));
            var rotate = Cesium.Matrix4.fromRotationTranslation(Cesium.Matrix3.fromHeadingPitchRoll(rotation, {}), Cesium.Cartesian3.ZERO, {});
            matrix = Cesium.Matrix4.multiplyTransformation(m, rotate, {});
            if (this.transform && this.transform.vertical_offset) {
                var newOri = Cesium.Matrix4.multiplyByPoint(matrix, this.origin, {});
                var cart = Cesium.Cartographic.fromCartesian(newOri);
                cart.height += this.transform.vertical_offset || 0;
                var neg = new Cesium.Cartesian3.subtract(Cesium.Cartographic.toCartesian(cart), newOri, {});
                m = Cesium.Matrix4.multiplyByTranslation(matrix, neg, {});
            }
        }
        else {
            var cart = Cesium.Cartographic.fromCartesian(point || this.origin);
            if (this.transform)
                cart.height += this.transform.vertical_offset || 0;
            var neg = new Cesium.Cartesian3.subtract(Cesium.Cartographic.toCartesian(cart), this.origin, {});
            matrix = Cesium.Matrix4.fromTranslation(neg, {});
        }
        this.obj.object.modelMatrix = matrix;
        if (this.transform)
            this.transform.matrix = Cesium.Matrix4.toArray(matrix);
        //this.voff()
    }
    clickedPoint(movement) {
        if (this.repick) {
            this.lastClick = this.viewer.scene.pickPosition(movement.position);
            this.adjustPoint(this.lastClick);
        }
    }
    voff() {
        if (!this.transform)
            return;
        Constants_1.Constants.showHangOn();
        try {
            this.helper.removePlottable(this.transform);
            this.helper.addPlottable(this.transform).subscribe(_ => Constants_1.Constants.hideHangOn());
        }
        catch (e) {
            console.log(e);
            Constants_1.Constants.hideHangOn();
        }
    }
    onClick() {
        this.dialogRef.close();
    }
    foucs() {
        if (this.transform)
            this.helper.sendCameraTo(this.transform);
        else if (this.kmlDataSource)
            this.viewer.flyTo(this.kmlDataSource);
    }
    ngOnDestroy() {
        /* if (this.viewer && this.viewer.scene) {
           this.viewer.scene.mode = Cesium.SceneMode.SCENE2D;
         }*/
    }
}
exports.MapDialog = MapDialog;
let OpenSeaDragon = require('openseadragon');
var b64toBlob = require('b64-to-blob');
class DZIDialog /*extends BaseComponent*/ {
    // private image: HTMLImageElement = new Image();
    constructor(service, fourd, router, snackBar, dialog, dialogRef, data, fourD, activatedRoute, mapService) {
        this.service = service;
        this.fourd = fourd;
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.dialogRef = dialogRef;
        this.data = data;
        this.fourD = fourD;
        this.activatedRoute = activatedRoute;
        this.mapService = mapService;
        this.image = null;
        this.imageName = null;
        this.imageUrl = 'https://beta.4dmapper.com/vasat/app/Account/user_1744_account/api/Dataset/212676/data?access_token=SQ0TFKGKFGKA0EFY4O3HJIYB1M4YWM034LVCDBLP';
        this.dziOpen = false;
        this.dziOpen2 = false;
        this.showCaptureButton = false;
        this.capturing = false;
        this.showOverLay = false;
        this.canMark = false;
        this.canClearMark = false;
        this.showDZICalled = false;
        this.zoomLevel = 0;
        this.maxZoom = 5;
        // super(service, router, snackBar, dialog);
    }
    AfterViewInit() { }
    ngOnInit() {
        // let state = this.router.routerState.snapshot.url;
        // console.log('@@@@@@@ map-dialog() router', state );
        this.activatedRoute.queryParams.subscribe(value => {
            console.log('@@@@@@@ map-dialog() query params', value);
            if (value && value.annotation) {
                this.showCaptureButton = true;
                this.annotationId = value.annotation;
            }
        });
        setTimeout(() => {
            this.image = document.getElementById('image');
            console.log('image', this.image);
        }, 500);
        var DZI = this.fourD.transformTypes.find(t => t.uid == 'photo-dzi');
        var THUMB = this.fourD.transformTypes.find(t => t.uid == 'thumb');
        this.transform = this.data.img;
        try {
            this.data.img.name = this.data.img.name.replace('THUMB', '').replace('JPG_DZI', '').replace('DZI', '').trim();
            this.imageName = this.data.img.name;
        }
        catch (e) {
            console.log(e);
        }
        // console.log ( "!!!!!!", this.fourD.transformTypes, this.data, this.data.img );
        // return;
        // if its already a DZI, just show
        if (this.transform.transformType == DZI) {
            this.showDZI();
        }
        // otherwise kick of processor
        else {
            console.log('trying to convert dzi');
            this.errorInApplyTransform = false;
            this.transform.input.applyTransform(DZI).subscribe(s => {
                /*var snackBarRef = this.snackBar.open('Please wait, we are converting the image into DZI', '', {horizontalPosition: 'center'});*/
                this.fourD.onSocketCommand('task_update').subscribe(value => {
                    if (value.dataset.id === this.data.img.input.id && value.status === 'finished') {
                        // !overlayAdded is a hack because we are getting two time socket update for dzi so openseadragon throws error if we add same overlay two times.
                        if (!this.showDZICalled) {
                            this.showDZICalled = true;
                            this.transform.fetchObservable().subscribe();
                            this.showDZI();
                        }
                        this.errorInApplyTransform = false;
                    }
                    else if (value.dataset.id === this.data.img.input.id && (value.status.toLowerCase() === 'failed' || value.status.toLowerCase() === 'error')) {
                        this.errorInApplyTransform = true;
                        this.snackBar.open('DIALOG.CONVERSION_ERROR', '', { duration: Constants_1.Constants.SNACKBAR_DURATION });
                    }
                });
            }, e => {
                this.errorInApplyTransform = true;
                console.log(e);
                this.snackBar.open('GENERIC.ERROR ' + e.message, '', { duration: Constants_1.Constants.SNACKBAR_DURATION });
            });
        }
    }
    update(what, value) {
        this.viewer.viewport[what] = value;
        // console.log ( 'map-dialog :: update()', what, value, this.viewer);
    }
    showDZI() {
        this.viewer = OpenSeaDragon({
            id: 'dragon',
            tileSources: this.data.img.file('data.dzi'),
            crossOriginPolicy: 'Anonymous',
            showNavigator: true,
            navigatorPosition: "BOTTOM_LEFT",
            minLevel: 8,
            width: 6425,
            height: 8535,
            tileSize: 256,
            tileOverlap: 1,
            maxZoomPixelRatio: 2.5
        });
        // console.log ( 'map-dialog :: showDZI()', this.viewer);
        if (this.mapService.selectedReference) {
            this.canMark = true;
            if (this.mapService.selectedReference.job[this.mapService.REFERENCE_ANNOTATION]) {
                if (this.mapService.selectedReference.referenceAnnotation.referenceAnnotationMarkedImages && this.mapService.selectedReference.referenceAnnotation.referenceAnnotationMarkedImages.length > 0) {
                    this.mapService.selectedReference.referenceAnnotation.referenceAnnotationMarkedImages.forEach(value => {
                        if (value.imageName === this.data.img.name) {
                            this.toBeCleared = value;
                            this.canClearMark = true;
                        }
                    });
                }
            }
            this.viewer.addHandler('update-viewport', () => {
                var canvas = this.drawCanvas();
                this.viewer.addHandler('canvas-click', (event) => {
                    var dpr = window.devicePixelRatio || 1;
                    var webPoint = new OpenSeaDragon.Point((canvas.width / dpr) / 2, (canvas.height / dpr) / 2);
                    var viewportPoint = this.viewer.viewport.pointFromPixel(webPoint);
                    this.imagePoint = this.viewer.viewport.viewportToImageCoordinates(viewportPoint);
                    console.log(this.imagePoint.toString());
                });
            });
        }
        // aware of selected_position
        this.viewer.addHandler('open', (event) => {
            if (this.data.img['selected_position'] && this.data.img['selected_position'].x !== -1 && this.data.img['selected_position'].y !== -1 && !this.toBeCleared) {
                var x = (this.data.img['selected_position'].x / this.data.img.image.image_width); // - (20 / this.data.img.image.image_width);
                var y = (this.data.img['selected_position'].y / this.data.img.image.image_width); // - (20 / this.data.img.image.image_width);
                console.log(x, y);
                if (!this.mapService.selectedReference) {
                    var IMAGE_RULER_HIGHLIGHT = 'right-arrow-overlay';
                    var IMAGE_RULER_DEFAULT_POSITION = new OpenSeaDragon.Point(x, y);
                    this.viewer.addOverlay(IMAGE_RULER_HIGHLIGHT, IMAGE_RULER_DEFAULT_POSITION, OpenSeaDragon.Placement.CENTER);
                    this.zoomToSelectedPosition();
                    this.showOverLay = true;
                }
                else {
                    this.showOverLay = false;
                    this.zoomToSelectedPosition();
                }
            }
            else {
                this.showOverLay = false;
            }
            this.dziOpen = true;
            if (this.toBeCleared) {
                var pixelCoords = new OpenSeaDragon.Point(this.toBeCleared.pixelX, this.toBeCleared.pixelY);
                var viewCoords = this.viewer.viewport.imageToViewportCoordinates(pixelCoords);
                this.viewer.viewport.zoomTo(this.viewer.viewport.getMaxZoom(), viewCoords, true);
                this.viewer.viewport.applyConstraints();
            }
            if (this.mapService.isCameraClicked) {
                this.showCaptureButton = true;
            }
        });
        this.viewer.addHandler('open-failed', (event) => {
            this.snackBar.open('GENERIC.ERROR ' + event.message, '', { duration: Constants_1.Constants.SNACKBAR_DURATION });
            this.dziOpen = false;
        });
    }
    zoomToSelectedPosition() {
        var pixelCoords = new OpenSeaDragon.Point(this.data.img['selected_position'].x, this.data.img['selected_position'].y);
        var viewCoords = this.viewer.viewport.imageToViewportCoordinates(pixelCoords);
        console.log('zoom to ', viewCoords);
        this.viewer.viewport.zoomTo(this.viewer.viewport.getMaxZoom(), viewCoords, true);
        this.viewer.viewport.applyConstraints();
    }
    drawCanvas() {
        var canvas = this.viewer.drawer.canvas;
        var ctx = this.viewer.drawer.context;
        if (this.toBeCleared) {
            ctx.strokeStyle = 'blue';
        }
        else {
            ctx.strokeStyle = 'red';
        }
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.arc(canvas.width / 2, canvas.height / 2, 25, 0, Math.PI * 2);
        ctx.arc(canvas.width / 2, canvas.height / 2, 26, 0, Math.PI * 2);
        ctx.arc(canvas.width / 2, canvas.height / 2, 27, 0, Math.PI * 2);
        ctx.moveTo(canvas.width / 2 - 10, canvas.height / 2);
        ctx.lineTo(canvas.width / 2 + 10, canvas.height / 2);
        ctx.moveTo(canvas.width / 2, canvas.height / 2 - 10);
        ctx.lineTo(canvas.width / 2, canvas.height / 2 + 10);
        ctx.moveTo(canvas.width / 2, canvas.height / 2 - 40);
        ctx.lineTo(canvas.width / 2, canvas.height / 2 - 30);
        ctx.moveTo(canvas.width / 2, canvas.height / 2 + 40);
        ctx.lineTo(canvas.width / 2, canvas.height / 2 + 30);
        ctx.moveTo(canvas.width / 2 - 40, canvas.height / 2);
        ctx.lineTo(canvas.width / 2 - 30, canvas.height / 2);
        ctx.moveTo(canvas.width / 2 + 40, canvas.height / 2);
        ctx.lineTo(canvas.width / 2 + 30, canvas.height / 2);
        ctx.stroke();
        return canvas;
    }
    /* viewer.world.addHandler('add-item', function (event) {
         var tiledImage = event.item;
         tiledImage.addHandler('fully-loaded-change', this.fullyLoadedHandler);
       });*/
    mark() {
        var dpr = window.devicePixelRatio || 1;
        var webPoint = new OpenSeaDragon.Point((this.viewer.drawer.canvas.width / dpr) / 2, (this.viewer.drawer.canvas.height / dpr) / 2);
        var viewportPoint = this.viewer.viewport.pointFromPixel(webPoint);
        this.imagePoint = this.viewer.viewport.viewportToImageCoordinates(viewportPoint);
        console.log('map-dialog :: mark()', this.imagePoint.toString(), this.data.img);
        if (this.mapService.selectedReference) {
            if (this.mapService.selectedReference.job[this.mapService.REFERENCE_ANNOTATION]) {
                if (this.toBeCleared) {
                    this.toBeCleared.pixelX = this.imagePoint.x;
                    this.toBeCleared.pixelY = this.imagePoint.y;
                    this.saveJob(false);
                }
                else {
                    if (!this.mapService.selectedReference.referenceAnnotation.referenceAnnotationMarkedImages || this.mapService.selectedReference.referenceAnnotation.referenceAnnotationMarkedImages.length === 0) {
                        this.mapService.selectedReference.referenceAnnotation.referenceAnnotationMarkedImages = [];
                    }
                    let image = new reference_annotation_markedImages_1.ReferenceAnnotationMarkedImages(this.data.img.name, this.imagePoint.x, this.imagePoint.y);
                    this.mapService.selectedReference.referenceAnnotation.referenceAnnotationMarkedImages.push(image);
                    this.saveJob(false);
                    this.toBeCleared = image;
                }
                this.data.img['markedInPhotogram'] = true;
                this.data.img['markedInPhotogramReference'] = this.mapService.selectedReference.referenceAnnotation;
                this.data.img.saveObservable().subscribe();
                var canvas = this.drawCanvas();
                this.canClearMark = true;
            }
        }
    }
    saveJob(closeDialoge) {
        this.mapService.selectedReference.job.saveObservable().subscribe(value => {
            // this.snackBar.open(Constants.SUCCESS_MESSAGE, '', {duration: Constants.duration});
            if (closeDialoge) {
                this.cnx();
            }
        });
    }
    clearMark() {
        if (this.mapService.selectedReference.referenceAnnotation.referenceAnnotationMarkedImages.findIndex(value => value === this.toBeCleared) !== -1) {
            this.mapService.selectedReference.referenceAnnotation.referenceAnnotationMarkedImages.splice(this.mapService.selectedReference.referenceAnnotation.referenceAnnotationMarkedImages.findIndex(value => value === this.toBeCleared), 1);
            this.toBeCleared = undefined;
            var canvas = this.drawCanvas();
            this.saveJob(false);
            this.canClearMark = false;
            this.data.img['markedInPhotogram'] = false;
            this.data.img.saveObservable().subscribe();
        }
    }
    cnx() {
        this.dialogRef.close(this.data);
    }
    captureScrenShot() {
        this.capturing = true;
        var osd_img = this.viewer.drawer.canvas.toDataURL('image/png');
        osd_img = osd_img.replace(/^data:image\/(png|jpeg|jpg);base64,/, '');
        var contentType = 'image/png';
        this.data.img.screenshotByteCharacters = b64toBlob(osd_img, contentType);
        this.mapService.onSingleImageForAttachementChange.next(this.data.img);
        this.data.screenshotCaptured = true;
        this.dialogRef.close(this.data);
        // this.uploadScreenShot(byteCharacters);
    }
    uploadScreenShot(byteCharacters) {
        let d = new Date();
        let imageName = d.getTime() + '.png';
        var xhr = new XMLHttpRequest();
        var upload = xhr.upload;
        upload.addEventListener('progress', (evt) => {
            if (evt.lengthComputable) {
                /* self.progress = ((self.loaded + evt.loaded) / self.total);
                 self.progressSubject.next(self.progress)*/
                console.log(evt);
            }
        }, false);
        xhr.onreadystatechange = () => {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (!xhr.responseText || xhr.responseText === '') {
                    this.snackBar.open(Constants_1.Constants.ERROR_MESSAGE, '', { duration: Constants_1.Constants.SNACKBAR_DURATION });
                    return;
                }
                // good response
                var res = JSON.parse(xhr.responseText);
                if (res.status && res.status === 200) {
                    {
                        this.snackBar.open(Constants_1.Constants.SUCCESS_MESSAGE, '', { duration: Constants_1.Constants.SNACKBAR_DURATION });
                        // this.openSnackBarSuccess(Constants.SUCCESS_MESSAGE);
                        this.data.screenshotCaptured = true;
                        this.cnx();
                    }
                    console.log('all good');
                    // all good
                }
                else if (res.status && res.status < 400) {
                    console.log('vasat error');
                    this.snackBar.open(Constants_1.Constants.ERROR_MESSAGE, '', { duration: Constants_1.Constants.SNACKBAR_DURATION });
                }
                else {
                    this.snackBar.open(Constants_1.Constants.ERROR_MESSAGE, '', { duration: Constants_1.Constants.SNACKBAR_DURATION });
                    console.log('all good');
                }
                this.capturing = false;
            }
        };
        xhr.open('POST', this.fourD.V.config.host + '/api/Annotation/' + this.annotationId + '/' + imageName);
        xhr.overrideMimeType('application/octet-stream');
        xhr.setRequestHeader('Content-Type', 'application/octet-stream');
        xhr.setRequestHeader('Authorization', 'Bearer ' + this.fourD.V.token);
        xhr.send(byteCharacters);
    }
}
exports.DZIDialog = DZIDialog;
/*
export function areAllFullyLoaded() {
  var tiledImage;
  var count = viewer.world.getItemCount();
  for (var i = 0; i < count; i++) {
    tiledImage = viewer.world.getItemAt(i);
    if (!tiledImage.getFullyLoaded()) {
      return false;
    }
  }
  return true;
}

export function fullyLoadedHandler() {
  if (areAllFullyLoaded()) {
    // removeFullyLoadedHandlers(); // since presumably you only want to do this once
    // loadHotSpots();
  }
}*/
